/**
 * @class LicensePointOfSale
 */
export default class LicensePointOfSale {
    /**
     * @param {String} zip
     * @param {String} street
     * @param {String} country
     * @param {String} region
     * @param {String} name
     * @param {String} city
     */
    constructor(name = "", street = "", country = "", region = "", city = "", zip = "") {
        this._name = name;
        this._street = street;
        this._country = country;
        this._region = region;
        this._city = city;
        this._zip = zip;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get street() {
        return this._street;
    }

    /**
     * @param {String} street
     */
    set email(street) {
        this._street = street;
    }

    /**
     * @return {String}
     */
    get country() {
        return this._country;
    }

    /**
     * @param {String} country
     */
    set country(country) {
        this._country = country;
    }

    /**
     * @return {String}
     */
    get region() {
        return this._region;
    }

    /**
     * @param {String} region
     */
    set region(region) {
        this._region = region;
    }

    /**
     * @return {String}
     */
    get city() {
        return this._city;
    }

    /**
     * @param {String} city
     */
    set city(city) {
        this._city = city;
    }

    /**
     * @return {String}
     */
    get zip() {
        return this._zip;
    }

    /**
     * @param {String} zip
     */
    set zip(zip) {
        this._zip = zip;
    }
}
